import { getApiBaseUrl } from "../config/apiBase";
import { apiFetch } from "../config/apiFetch";
import type { EngineerMaster } from "../types";

async function parseError(res: Response): Promise<string> {
  const text = await res.text();
  try {
    const j = JSON.parse(text) as { error?: string };
    if (j.error) return j.error;
  } catch {
    /* ignore */
  }
  return text || `Request failed (${res.status})`;
}

export async function fetchEngineerMasters(): Promise<EngineerMaster[]> {
  const res = await apiFetch(`${getApiBaseUrl()}/api/engineer-masters`);
  if (!res.ok) throw new Error(await parseError(res));
  return res.json() as Promise<EngineerMaster[]>;
}

export async function createEngineerMasterApi(
  row: Omit<EngineerMaster, "id" | "createdAt">,
): Promise<EngineerMaster> {
  const res = await apiFetch(`${getApiBaseUrl()}/api/engineer-masters`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(row),
  });
  if (!res.ok) throw new Error(await parseError(res));
  return res.json() as Promise<EngineerMaster>;
}

export async function updateEngineerMasterApi(
  id: string,
  patch: Partial<Omit<EngineerMaster, "id" | "createdAt">>,
): Promise<EngineerMaster> {
  const res = await apiFetch(`${getApiBaseUrl()}/api/engineer-masters/${encodeURIComponent(id)}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(patch),
  });
  if (!res.ok) throw new Error(await parseError(res));
  return res.json() as Promise<EngineerMaster>;
}

export async function deleteEngineerMasterApi(id: string): Promise<void> {
  const res = await apiFetch(`${getApiBaseUrl()}/api/engineer-masters/${encodeURIComponent(id)}`, {
    method: "DELETE",
  });
  if (!res.ok) throw new Error(await parseError(res));
}
